module.exports = __webpack_public_path__ + "static/media/recommended-1.9978740f.png";